<div>
<p-image src="../../../assets/img/Group 1.png" alt="Image" class="centro"></p-image>
<div class="texto">
    <h1><b>Lo sentimos...</b></h1>
    <h2 style="font-weight: normal;">No cuentas con permisos para acceder a este contenido.</h2>
  </div>
</div>